/**
 * Local development entry point.
 * In production, ModuleApp is loaded as a remote module by the xplatform shell.
 */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@config/i18n";
import ModuleApp from "@src/ModuleApp";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <ModuleApp />
  </BrowserRouter>
);
